var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHangUp = function SvgHangUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 34 34"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "inherit",
    clipPath: "url(#clip0_1139_17427)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m24.381 22.316-2.233-2.235a2.1 2.1 0 0 0-2.408-.388c-1.184.549-2.825-.321-3.928-1.419-1.117-1.11-1.991-2.743-1.44-3.907a2.09 2.09 0 0 0-.403-2.423L11.722 9.71a2.07 2.07 0 0 0-1.493-.615c-.552 0-1.09.214-1.494.615-2.313 2.289-2.313 6.036-.013 8.338l7.251 7.213a5.92 5.92 0 0 0 4.197 1.727c1.588 0 3.081-.616 4.198-1.727.403-.388.619-.923.619-1.485s-.216-1.084-.62-1.486zm-1.116 1.753-.068.054a4.26 4.26 0 0 1-3.027 1.244 4.28 4.28 0 0 1-3.04-1.258h-.013l-7.211-7.2a4.22 4.22 0 0 1-1.251-3.01 4.22 4.22 0 0 1 1.25-3.012.45.45 0 0 1 .633 0l2.247 2.235a.444.444 0 0 1 .094.535c-.794 1.66-.108 3.935 1.762 5.782s4.144 2.53 5.812 1.74a.45.45 0 0 1 .525.08l2.233 2.235c.161.16.175.401.04.589z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M24.65 9.215a.946.946 0 0 1 .135 1.324l-4.897 4.872c-.323.401-.928.455-1.332.134a.946.946 0 0 1-.134-1.325l4.91-4.872c.323-.401.928-.455 1.332-.134z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m19.888 9.348 4.897 4.872c.323.401.269.99-.135 1.325a.96.96 0 0 1-1.332-.134l-4.896-4.872a.947.947 0 0 1 .134-1.325.96.96 0 0 1 1.332.134",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1139_17427"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    d: "M7 9h18v18H7z"
  })))));
};
export default SvgHangUp;